// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o7-0";
export var buttonContainer = "_o7-3";
export var cancelButton = "_o7-4";
export var headerSection = "_o7-6";
export var headerTitle = "_o7-9";
export var messageSideLeft = "_o7-1";
export var messageSideRight = "_o7-2";
export var orderNumberContainer = "_o7-7";
export var orderNumberLabel = "_o7-8";
export var submitButton = "_o7-5";